// /utils/playNotificationSound.ts
let audio: HTMLAudioElement | null = null;
let isAudioLoaded = false;

export const initializeAudio = () => {
  if (!audio) {
    audio = new Audio('/sounds/notification.mp3');
    audio.preload = 'auto';
    
    audio.addEventListener('canplaythrough', () => {
      isAudioLoaded = true;
    });
    
    audio.addEventListener('error', () => {
      console.error('Failed to load notification sound');
      isAudioLoaded = false;
    });
  }
};

export const playNotificationSound = () => {
  const permission = localStorage.getItem('soundPermission');
  if (permission !== 'granted') return;

  if (!audio || !isAudioLoaded) {
    console.warn('Notification sound not ready');
    return;
  }

  const play = () => {
    try {
      audio!.currentTime = 0;
      const playPromise = audio!.play();
      
      if (playPromise !== undefined) {
        playPromise.catch(err => {
          console.warn('Audio play failed:', err);
          // Fallback: Try again with user gesture
          document.addEventListener('click', () => {
            audio!.play().catch(() => {});
          }, { once: true });
        });
      }
    } catch (err) {
      console.warn('Audio play error:', err);
    }
  };

  if (document.visibilityState === 'visible') {
    play();
  } else {
    const handler = () => {
      if (document.visibilityState === 'visible') {
        play();
        document.removeEventListener('visibilitychange', handler);
      }
    };
    document.addEventListener('visibilitychange', handler);
  }
};